(function () {
    angular
      .module('kareo.ui.shared.directives.k-enrl-electronic-payers', [
        'kareo.ui.shared.directives.k-enrl-common-payers',
        'kareo.ui.shared.directives.k-enrl-payer-search',
        'kareo.ui.shared.directives.k-enrl-ready-payers',
        'kareo.ui.shared.directives.k-enrl-phase-3-selected-payers',
        'kareo.ui.shared.modules.data',
        'kareo.ui.shared.modules.featureSet'
      ])
      .directive('kEnrlElectronicPayers', kEnrlElectronicPayers);

    function kEnrlElectronicPayers() {
      const directive = {
        bindToController: true,
        controller,
        controllerAs: 'vm',
        scope: {
          payers: '=',
          practiceState: '=',
          addInsuranceCheck: '=',
          allowMultipleInsurances: '='
        },
        template: require('./k-enrl-electronic-payers.pug')()
      };

      return directive;
    }

    //----------------------
    controller.$inject = [ '$scope', 'featureSet', 'practice', 'enrollmentsService'];

    function controller($scope, featureSet, practice, enrollmentsService) {
      const vm = this;
      init();

      vm.previousInsuranceSelected = false;
      vm.addCommonPayers = addCommonPayers;
      vm.onPayerAdd = onPayerAdd;
      vm.removePayer = removePayer;
      vm.commonPayers = [];
      vm.addedPayers = [];
      vm.tabs = { ready: 'Read for Electronic Connection', common: 'Most Commonly Requested', search: 'Search Other' };
      vm.selectedTab = vm.tabs.common;

      $scope.$on('showWithoutPayerIdAlert', (event, data) => {
        vm.lastAddedPayer = data;
      });

      function init() {
        featureSet.load()
        .then(featuresHandler)
        .then(enrollmentsService.getPayerDetails)
        .then(payerDetailsHandler);

        practice.get().then((result) => {
          vm.pmEnabled = result.pmenabled;
        });
      }

      function featuresHandler(features) {
        vm.isInsuranceAdmin = features['dark-feature.converged-insurance-admin'];
        vm.isAddInsuranceFeatureEnabled = features['dark-feature.enrollments-add-insurance'];
        return !!vm.isInsuranceAdmin;
      }

      function payerDetailsHandler(result) {
        vm.addedPayers = result;
      }

      function addCommonPayers() {
        vm.payers = vm.payers.concat(vm.commonPayers);
        vm.commonPayers = [];
      }

      function onPayerAdd(payer) {
        if(vm.lastAddedPayer != null && !vm.allowMultipleInsurances){
          vm.previousInsuranceSelected = true;
        }
        vm.lastAddedPayer = payer;
        vm.lastAddedPayer.isWithoutPayerId = false;
      }

      function removePayer(payer) {
        if (vm.lastAddedPayer && vm.lastAddedPayer.clearinghousePayerId === payer.clearinghousePayerId) {
          vm.lastAddedPayer = undefined;
          vm.previousInsuranceSelected = false;
        }
      }
    }
  })();
